import { render, staticRenderFns } from "./kunden.vue?vue&type=template&id=f6364e98&scoped=true&"
import script from "./kunden.vue?vue&type=script&lang=js&"
export * from "./kunden.vue?vue&type=script&lang=js&"
import style0 from "./kunden.vue?vue&type=style&index=0&id=f6364e98&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6364e98",
  null
  
)

export default component.exports